import PieChart from './PieChart';

export default class DonutChart extends PieChart {

    cutout: string = "50%";

}
